import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    productIndex: -1,
    productScdIndex: -1
  },
  mutations: {
    setProductIndex(state, obj) {
      return state.productIndex = obj.index
    },
    setProductScdIndex(state, obj) {
      return state.productScdIndex = obj.index
    },
  },
  actions: {}
});